module.exports = __webpack_public_path__ + "static/media/Icon-arrow-red-up.6b537c00.png";